import { useEffect, useState } from "react";
import { TurnPhase } from "~/business";
import { FontSize, Spacing, ZIndex } from "~/jsx/theme";
import { expectNever } from "~/utils";
import { XCardIconSvg } from "./svg";
import { XCrossedSwordsSvg } from "./svg";
import { XTravelingContent } from "./XTravelingContent";
import { XTypography } from "./XTypography";
import { useGame } from "~/app";

enum DisplayedPhase {
  Combat = "Combat",
  Play = "New turn",
}
const animationDuration = 3000;

export const XPhase = () => {
  const { game } = useGame();
  const { turnPhase } = game;
  const displayedPhase = phaseToDisplayedPhase(turnPhase);
  const [lastPhase, setLastPhase] = useState(displayedPhase);
  useEffect(() => {
    if (lastPhase !== displayedPhase) {
      const timeout = setTimeout(() => {
        setLastPhase(displayedPhase);
      }, animationDuration);
      return () => clearTimeout(timeout);
    }
  }, [displayedPhase, lastPhase]);

  if (lastPhase === displayedPhase) {
    return null;
  }

  return (
    <XTravelingContent
      durationInMs={animationDuration}
      style={{ zIndex: ZIndex.modal }}
    >
      <XTypography
        style={{
          textAlign: "center",
          fontSize: FontSize.px28,
          marginBottom: Spacing.px24,
        }}
      >
        {displayedPhase}
      </XTypography>
      {getIcon(displayedPhase)}
    </XTravelingContent>
  );
};

const phaseToDisplayedPhase = (phase: TurnPhase): DisplayedPhase => {
  switch (phase) {
    case TurnPhase.RoundStart:
    case TurnPhase.Play:
    case TurnPhase.Reveal:
    case TurnPhase.Shop:
      return DisplayedPhase.Play;
    case TurnPhase.CombatStart:
    case TurnPhase.CombatEnd:
    case TurnPhase.Cleanup:
    case TurnPhase.EndGame:
      return DisplayedPhase.Combat;
    default:
      expectNever(phase);
      throw new Error("expect never");
  }
};

const getIcon = (phase: DisplayedPhase) => {
  switch (phase) {
    case DisplayedPhase.Combat:
      return <XCrossedSwordsSvg width={128} />;
    case DisplayedPhase.Play:
      return <XCardIconSvg width={128} />;
    default:
      expectNever(phase);
  }
};
